'use strict';

var GridToolbarUserManagementManageUsersController = function GridToolbarUserManagementManageUsersController($scope) {
  $scope.selectedRows = [];
  $scope.isEditButtonShown = false;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
    $scope.isEditButtonShown = selectedRows.length === 1;
  };
  $scope.removeUsers = function () {
    $scope.$emit('user-management-manage-users-grid: showDeleteModal', $scope.selectedRows);
  };
  $scope.userProfile = function () {
    $scope.$emit('user-management-manage-users-grid:edit', $scope.selectedRows);
  };
};
GridToolbarUserManagementManageUsersController.$inject = ['$scope'];
module.exports = GridToolbarUserManagementManageUsersController;